export default __webpack_public_path__ + "static/media/classification-blue.6df704c6.svg";